import { Pipe, PipeTransform } from "@angular/core";
import { Message } from "../definition";
import { Store } from "@ngxs/store";
import { AppState } from "../stores/app.state";

@Pipe({
    name: "messageUser"
})
export class MessageUserPipe implements PipeTransform {
    constructor(private store: Store) {}
    transform(message: Message): any {
        const currentUser = this.store.selectSnapshot(AppState.user);
        if (message.sender.uuid === currentUser.uuid) {
            return message.receiver;
        } else {
            return message.sender;
        }
    }
}
